import React from 'react';
import { connect } from 'react-redux';
import { IRootState } from 'app/shared/reducers';
import { Button, Row, Col, Modal, ModalHeader, ModalBody, Alert, ModalFooter } from 'reactstrap';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import { Storage, Translate, translate } from 'react-jhipster';
import '../../user/profile.scss';
import '../../../sendOtp/sendOtp.scss';
import OtpInput from 'react-otp-input';
import { reSendOtp, sendOtp } from 'app/modules/sendOtp/sendOtp.reducer';
import { MESSAGE, Rester_Type } from 'app/config/constants';
import { generateCaptcha } from 'app/modules/account/password-reset/password-reset.reducer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { cancelUser, resetCancelUser } from 'app/modules/administration/approve-management/approve-management.reducer';

export interface ICancelAccountProps extends StateProps, DispatchProps {
  isDisplay: boolean;
  invokeCloseModal: Function;
  invokeSuccess: Function;
  showListCancelAccount: Function;
  id: any;
  type: any;
}

export interface ICancelAccountState {
  visible: boolean;
  color: string;
  message: string;
  isDisable: boolean;
  redirectUrl: boolean;
  alertMess: string;
  isOpenAlert: boolean;
}

export class CancelAccountEditInfo extends React.Component<ICancelAccountProps, ICancelAccountState> {
  state: ICancelAccountState = {
    visible: false,
    color: 'info',
    message: '',
    isDisable: false,
    redirectUrl: false,
    alertMess: '',
    isOpenAlert: false
  };

  componentDidUpdate(prevProps) {
    if (this.props.resCancelUser !== prevProps.resCancelUser) {
      this.setState({
        color: 'success',
        visible: true,
        message: 'Gửi yêu cầu thành công.'
      });

      let timerId = setTimeout(() => {
        this.setState({
          visible: false,
          color: 'info',
          message: ''
        });
        this.toggle();
      }, 3000);
    }
  }

  toggle = () => {
    this.props.invokeCloseModal();
  };
  handleValidSubmit = (event, values) => {
    this.props.cancelUser(values.reason);
  };

  isDataEmpty(ob) {
    for (var i in ob) {
      return false;
    }
    return true;
  }

  onDismiss = () => {
    this.setState({ visible: false });
  };

  render() {
    const { id } = this.props;

    return (
      <div className="container-fluid">
        <Modal
          className="modal-lg hide-border-bottom-modal"
          isOpen={this.props.isDisplay}
          toggle={this.toggle}
          size="lg"
          backdrop="static"
          centered={window.location === window.parent.location}
          style={{ maxWidth: window.innerWidth < 768 ? '100%' : '60%' }}
        >
          <ModalHeader toggle={this.toggle}>
            <h3 className="font-weight-bold">Đăng ký hủy tài khoản</h3>
          </ModalHeader>
          <ModalBody className="custom-scrollbar" style={{ paddingTop: '0px', paddingLeft: '2%', overflow: 'auto' }}>
            <Alert color={this.state.color} isOpen={this.state.visible} toggle={this.onDismiss}>
              {this.state.message}
            </Alert>
            <AvForm id="updateUser-form" onValidSubmit={this.handleValidSubmit}>
              <Row>
                <Col md="4">
                  <label>Tên người dùng:</label>
                </Col>
                <Col md="8">
                  <span className="font-weight-bold">{this.props.userProfile.fullname}</span>
                </Col>
              </Row>
              <Row>
                <Col md="12">
                  Lý do đăng ký hủy<span style={{ color: 'red' }}>*</span>:
                </Col>
              </Row>
              <Row>
                <Col md="12">
                  <AvField
                    style={{ height: '150px', fontSize: '15px' }}
                    name="reason"
                    type="textarea"
                    label=""
                    placeholder="Nhập lý do"
                    validate={{
                      required: { value: true, errorMessage: 'Lý do không được để trống!' }
                    }}
                  />
                </Col>
              </Row>
              <Row className="row justify-content-center">
                <Col md="4">
                  <Button style={{ width: '100%' }} className="btn-register-white" onClick={this.toggle}>
                    <Translate contentKey="entity.action.cancel">Cancel</Translate>
                  </Button>
                </Col>
                <Col md="4">
                  <Button className="btn-register" type="submit" disabled={this.state.isDisable} block>
                    Gửi Đăng ký
                  </Button>
                </Col>
                <Col md="4">
                  <Button style={{ width: '100%' }} className="btn-register-white" onClick={this.props.showListCancelAccount}>
                    Xem danh sách đăng ký
                  </Button>
                </Col>
              </Row>
            </AvForm>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (storeState: IRootState) => ({
  response: storeState.sendotp.response,
  responseReSend: storeState.sendotp.responseReSend,
  infoNewPhone: storeState.sendotp.infoNewPhone,
  userProfile: storeState.userInfo.userProfile,
  registrationFailure: storeState.sendotp.registrationFailure,
  resCancelUser: storeState.approveManagement.resCancelUser
});
const mapDispatchToProps = { reSendOtp, sendOtp, generateCaptcha, cancelUser };
type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CancelAccountEditInfo);
